export const tenantRoutes = (prefix = 'tenant') => ({
	tenantChangePassword: { path: `/${prefix}/change-password` },
	tenantUsers: { path: `/${prefix}/users` },
	tenantInviteUser: { path: `/${prefix}/invite-user` },
	tenantEditUser: { path: `/${prefix}/edit-user/:id` },
})
